<template>
  <div>
    <Breadcrumb msg1="会员管理" msg2="优惠券" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-input v-model="query.name" placeholder="券名称" clearable></el-input></el-col>
        <el-col :span="4">
          <el-select v-model="query.type" placeholder="类型" clearable>
            <el-option label="代金券" value="代金券"></el-option>
            <el-option label="折扣券" value="折扣券"></el-option>
            <el-option label="兑换券" value="兑换券"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新建模板</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="名称" prop="name" width="160"></el-table-column>
        <el-table-column label="类型" prop="type" width="100"></el-table-column>
        <el-table-column label="满减门槛" prop="threshold" width="100"></el-table-column>
        <el-table-column label="面值/折扣" prop="value" width="110"></el-table-column>
        <el-table-column label="有效天数" prop="validDays" width="100"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">停用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="480px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="券名称" required><el-input v-model="form.name"></el-input></el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" style="width: 100%">
            <el-option label="代金券" value="代金券"></el-option>
            <el-option label="折扣券" value="折扣券"></el-option>
            <el-option label="兑换券" value="兑换券"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="满减门槛"><el-input v-model.number="form.threshold" type="number"></el-input></el-form-item>
        <el-form-item label="面值/折扣"><el-input v-model="form.value"></el-input></el-form-item>
        <el-form-item label="有效天数"><el-input v-model.number="form.valid_days" type="number"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, name: '', type: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {}
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      this.$axios.get('/coupons', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    add () {
      this.dialogTitle = '新建优惠券模板'
      this.form = { name: '', type: '代金券', threshold: 0, value: 0, valid_days: 30 }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑优惠券模板'
      this.form = Object.assign({}, row)
      this.show = true
    },
    save () {
      if (!this.form.name) { this.$message.warning('名称必填'); return }
      if (this.form.id) {
        this.$axios.put(`/coupons/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/coupons', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/coupons/${id}`, () => this.getData())
    }
  }
}
</script>
